import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { Controller, useForm } from "react-hook-form";
import { useFetchEntityConfig } from "features/metadesk/redux/hooks";
import {
  Button,
  COLOR,
  VARIANT,
} from "@metacrm/metacrm-material-ui/dist/Button";
import AutoCompleteDropdown from "@metacrm/metacrm-material-ui/dist/AutoCompleteDropdown";
import {
  StyledBasicModalContainer,
  StyledCloseBtn,
  StyledModalTitle,
  StyledModalContent,
  StyledButtonArea,
  StyledLabel,
} from "./Modal.styles";
import _ from "lodash";
import { useIntl } from "react-intl";
import { useTheme } from "@mui/styles";
import { enqueueSnackbar } from "features/common/redux/actions";
import { useDispatch } from "react-redux";

export default function AddKolToGroupModal({
  open,
  handleClose,
  entityName,
  choose,
}) {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const { entityConfig } = useFetchEntityConfig();
  const dispatch = useDispatch();

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: "onSubmit",
    defaultValues: { selectedKolGroup: "", selectedKols: choose },
  });

  useEffect(() => {
    reset({
      selectedKolGroup: "",
      selectedKols: choose,
    });
  }, [choose]);

  // tmp mock data
  const kolGroupsData = [
    {
      _id: null,
      value: "all",
      label: "All",
    },
    {
      _id: "5f95d9d5",
      value: "5f95d9d5",
      label: "KOL Group 1",
      kols: [
        "5f95d9d5",
        "5f95d9d6",
        "5f95d9d7",
        "5f95d9d8",
        "5f95d9d9",
        "5f95d9da",
      ],
    },
    {
      _id: "5f95d9d6",
      value: "5f95d9d6",
      label: "KOL Group 2",
      kols: ["5f95d9d6", "5f95d9d7"],
    },
    {
      _id: "5f95d9d7",
      value: "5f95d9d7",
      label: "KOL Group 3",
      kols: ["5f95d9d7", "5f95d9d8"],
    },
  ];

  const onSubmit = async (data) => {
    try {
      console.log("Add KOL to Group Modal submit with data:", data);
      dispatch(
        enqueueSnackbar({
          message: formatMessage({ id: "kolGroup.addKolToGroup.success" }),
          options: { variant: "success" },
        })
      );
      closeModal();
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: formatMessage({ id: "kolGroup.addKolToGroup.error" }),
          options: { variant: "error" },
        })
      );
    }
  };

  const closeModal = () => {
    handleClose();
    setTimeout(() => reset(), 300); // wait for modal to unmount
  };

  return (
    <Modal
      open={open}
      className={"modal"}
      onClose={closeModal}
      sx={{ zIndex: 10000 }}
    >
      <StyledBasicModalContainer>
        <StyledModalTitle>
          <Box>{formatMessage({ id: "kolGroup.addKoltoGroup.title" })}</Box>
          <StyledCloseBtn
            size={24}
            color={theme.customColors.grey[700]}
            onClick={closeModal}
          >
            <i className="meta-crm-icon-ic_cancel" />
          </StyledCloseBtn>
        </StyledModalTitle>
        <StyledModalContent>
          <StyledLabel>
            {formatMessage({
              id: "kolGroup.kolGroup.label",
            })}{" "}
            <span style={{ color: theme.customColors.pink[600] }}>*</span>
          </StyledLabel>
          <Controller
            name="selectedKolGroup"
            control={control}
            rules={{
              required: {
                value: true,
                message: formatMessage({ id: "global.error.requiredField" }),
              },
            }}
            render={({ field }) => (
              <AutoCompleteDropdown
                size="large"
                value={field.value}
                options={kolGroupsData}
                onChange={(event, newValue) => {
                  field.onChange(newValue); // 通知 react-hook-form
                }}
                customNodeInOption={
                  <Box paddingLeft="16px" mb="8px">
                    <Box
                      color={(theme) => theme.customColors.grey[600]}
                      sx={{ fontSize: "12px", fontWeight: 600 }}
                    >
                      {formatMessage({
                        id: "dropdown.instruction.createKolGroup",
                      })}
                    </Box>
                  </Box>
                }
              />
            )}
          />
        </StyledModalContent>
        <StyledButtonArea>
          <Button
            color={COLOR.SECONDARY}
            variant={VARIANT.TEXT}
            onClick={closeModal}
            style={{ width: 120 }}
          >
            {formatMessage({ id: "global.btn.cancel" })}
          </Button>
          <Button
            color={COLOR.SECONDARY}
            disabled={!isValid}
            onClick={handleSubmit(onSubmit)}
            style={{ width: 120 }}
          >
            {formatMessage({ id: "global.btn.create" })}
          </Button>
        </StyledButtonArea>
      </StyledBasicModalContainer>
    </Modal>
  );
}
